import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./App.scss";
import "./App.css";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter} from "react-router-dom";

ReactDOM.render(
  <BrowserRouter>
    <App />,
  </BrowserRouter>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
serviceWorker.unregister();
